import {
  put, call, debounce, select,
} from "redux-saga/effects";
import {
  addNotification,
  changeTableItemsTotalAmount,
  setTableData,
  getTableFilters,
  getTablePage,
  getTablePageSize,
  getTableSorting,
  parseResponse,
} from "@fas/ui-framework";
import { GET_REDIRECT_LIST_SAGA, REDIRECT_LIST } from "../../helpers/constants";
import RedirectApi from "../../services/redirectApi";
import setLoading from "../../actions/loading";
import type { Redirect } from "../../reducers/redirectList";

type Order = "asc" | "desc";
type Filters = { [key: string]: string };
type Sorting = { [key: string]: Order };

export function* makeFetch() {
  try {
    yield put(setLoading(REDIRECT_LIST, true));
    const page: number = yield select(getTablePage, REDIRECT_LIST);
    const pageSize: number = yield select(getTablePageSize, REDIRECT_LIST);
    const filters: Filters = yield select(getTableFilters, REDIRECT_LIST);
    const sorting: Sorting = yield select(getTableSorting, REDIRECT_LIST);

    const response: {
      data: {
        data: { redirectList: Redirect[], count: number }
      }
    } = yield call(
      RedirectApi.getRedirectList,
      {
        page,
        pageSize,
        filters,
        sorting,
      }
    );
    const { data: { redirectList, count } } = response.data;
    yield put(setTableData(REDIRECT_LIST, redirectList));
    yield put(changeTableItemsTotalAmount(REDIRECT_LIST, count));
  }
  catch (error: any) {
    yield put(addNotification({ message: parseResponse(error), severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
    yield put(setTableData(REDIRECT_LIST, []));
  }
  finally {
    yield put(setLoading(REDIRECT_LIST, false));
  }
}

export default function* watch() {
  yield debounce(1000, GET_REDIRECT_LIST_SAGA, makeFetch);
}
